import type { Advisor } from '@/types'

import { useMemo } from 'react'
import { formatTime } from '@/lib/format'
import {
    formatDayLabel,
    TIMEZONE_LABEL,
    upcomingDays
} from '@/lib/schedule'
import { useMounted } from '@/hooks/use-mounted'

interface NextAvailableProps {
    advisor: Pick<Advisor, 'availableDays' | 'timeSlots'>
    className?: string
}

/**
 * The next open slot depends on today's date, so it is worked out in the
 * browser after the page loads. Until then the advisor's weekdays show.
 */
export const NextAvailable = ({ advisor, className }: NextAvailableProps) => {
    const mounted = useMounted()

    const label = useMemo(() => {
        if (!mounted) return null

        const [day] = upcomingDays(advisor.availableDays, new Date(), 1)
        const time = advisor.timeSlots[0]

        return day && time ? `${formatDayLabel(day.date)}, ${formatTime(time)} ${TIMEZONE_LABEL}` : null
    }, [mounted, advisor.availableDays, advisor.timeSlots])

    return (
        <span className={className}>
            {label ?? `Typically ${advisor.availableDays.join(', ')}`}
        </span>
    )
}
